// Service images
import img01 from "../images/main/ai_autoamtion.png";
import img02 from "../images/main/ai_product.png";
import img03 from "../images/main/webapp.png";
import img04 from "../images/main/ecomm.png";
import img06 from "../images/main/erp.png";
import img07 from "../images/main/blockchain.jpg";

export interface ServiceData {
    id: number;
    slug: string;
    title: string;
    shortDesc: string;
    img: string;
    fullDescription: string;
    secondaryDescription: string;
    outcomes: string[];
    videoUrl?: string;
}

export const servicesData: ServiceData[] = [
    {
        id: 1,
        slug: "ai-agents",
        title: "AI Agents",
        shortDesc: "Develop and deploy autonomous AI agents designed to handle complex multi-step workflows, automate decision-making, and interact intelligently with your existing systems.",
        img: img01,
        fullDescription: "Transform your business operations with our cutting-edge AI Agents that can autonomously execute complex tasks, make intelligent decisions, and seamlessly integrate with your existing systems. Our AI agents leverage advanced machine learning algorithms, natural language processing, and reinforcement learning to deliver exceptional results.",
        secondaryDescription: "From customer service automation to data analysis and process optimization, our AI agents adapt to your specific business needs. They learn from interactions, improve over time, and provide 24/7 intelligent support that scales with your organization.",
        outcomes: [
            "Autonomous Task Execution",
            "Intelligent Decision Making",
            "24/7 Operational Support",
            "Seamless System Integration",
            "Continuous Learning & Improvement",
            "Scalable AI Infrastructure",
        ],
        videoUrl: "https://www.youtube.com/embed/F8NKVhkZZWI?autoplay=1",
    },
    {
        id: 2,
        slug: "ai-product-engineering",
        title: "AI Product Engineering",
        shortDesc: "Transform conceptual ideas into production-ready AI solutions, handling everything from custom model training to seamless API integration and scalable architecture.",
        img: img02,
        fullDescription: "Turn your AI vision into reality with our comprehensive AI Product Engineering services. We take your ideas from concept to production, building custom machine learning models, designing scalable architectures, and ensuring seamless integration with your existing technology stack.",
        secondaryDescription: "Our team of AI engineers specializes in end-to-end product development, from initial prototyping to deployment and monitoring. We use industry best practices to ensure your AI products are robust, scalable, and ready for real-world applications.",
        outcomes: [
            "Custom ML Model Development",
            "Production-Ready Architecture",
            "API Integration & Deployment",
            "Scalable Cloud Infrastructure",
            "Continuous Model Training",
            "Performance Monitoring & Optimization",
        ],
        videoUrl: "https://www.youtube.com/embed/F8NKVhkZZWI?autoplay=1",
    },
    {
        id: 3,
        slug: "intelligent-web-apps",
        title: "Intelligent Web Apps",
        shortDesc: "Develop high-performance web platforms integrated with NLP-driven chatbots and virtual assistants to automate user engagement and provide 24/7 intelligent support.",
        img: img03,
        fullDescription: "Build next-generation web applications powered by artificial intelligence. Our intelligent web apps combine beautiful UI/UX with powerful AI capabilities including NLP-driven chatbots, personalized recommendations, and predictive analytics to deliver exceptional user experiences.",
        secondaryDescription: "We create web platforms that understand your users, anticipate their needs, and provide intelligent responses in real-time. From e-commerce to enterprise portals, our intelligent web apps drive engagement and conversion.",
        outcomes: [
            "NLP-Powered Chatbots",
            "Personalized User Experiences",
            "Real-Time Analytics Dashboard",
            "Intelligent Search & Recommendations",
            "Automated Customer Support",
            "Progressive Web App Features",
        ],
        videoUrl: "https://www.youtube.com/embed/F8NKVhkZZWI?autoplay=1",
    },
    {
        id: 4,
        slug: "smart-ecommerce",
        title: "Smart E-commerce",
        shortDesc: "Optimize digital storefronts using AI-powered recommendation engines, dynamic pricing algorithms, and real-time consumer behavior analytics.",
        img: img04,
        fullDescription: "Revolutionize your e-commerce platform with AI-driven features that boost sales and customer satisfaction. Our smart e-commerce solutions include personalized product recommendations, dynamic pricing optimization, inventory prediction, and customer behavior analytics.",
        secondaryDescription: "Leverage machine learning to understand your customers better, predict trends, and automate key business decisions. Our solutions help you stay ahead of the competition with data-driven strategies.",
        outcomes: [
            "AI-Powered Product Recommendations",
            "Dynamic Pricing Optimization",
            "Inventory Demand Forecasting",
            "Customer Behavior Analytics",
            "Automated Marketing Campaigns",
            "Fraud Detection & Prevention",
        ],
        videoUrl: "https://www.youtube.com/embed/F8NKVhkZZWI?autoplay=1",
    },
    {
        id: 5,
        slug: "blockchain-solutions",
        title: "Blockchain Solutions",
        shortDesc: "Build secure, decentralized applications using Hyperledger frameworks, Smart Contracts, and DApps. Enable transparent transactions and trustless automation across your enterprise.",
        img: img07,
        fullDescription: "Embrace the future of decentralized technology with our comprehensive blockchain solutions. We specialize in Hyperledger frameworks, Ethereum smart contracts, and custom blockchain development to create transparent, secure, and immutable systems for your business.",
        secondaryDescription: "From supply chain tracking to financial transactions and digital identity management, our blockchain solutions provide the trust and transparency your business needs in the digital age.",
        outcomes: [
            "Hyperledger Implementation",
            "Smart Contract Development",
            "Decentralized Application (DApp) Creation",
            "Supply Chain Transparency",
            "Secure Digital Transactions",
            "Tokenization & NFT Solutions",
        ],
        videoUrl: "https://www.youtube.com/embed/F8NKVhkZZWI?autoplay=1",
    },
    {
        id: 6,
        slug: "cognitive-erp",
        title: "Cognitive ERP & Business Logic",
        shortDesc: "Modernize enterprise resource planning with automated data entry, intelligent forecasting, and AI-assisted workflow optimization to eliminate operational silos.",
        img: img06,
        fullDescription: "Transform your enterprise operations with AI-enhanced ERP solutions that automate routine tasks, provide intelligent insights, and optimize workflows. Our cognitive ERP systems integrate seamlessly with your existing infrastructure while adding powerful AI capabilities.",
        secondaryDescription: "From automated data entry to predictive maintenance and intelligent forecasting, our solutions help enterprises operate more efficiently and make data-driven decisions at every level.",
        outcomes: [
            "Automated Data Entry & Processing",
            "Intelligent Business Forecasting",
            "Workflow Optimization",
            "Real-Time Decision Support",
            "Cross-Department Integration",
            "Predictive Analytics Dashboard",
        ],
        videoUrl: "https://www.youtube.com/embed/F8NKVhkZZWI?autoplay=1",
    },
];

// Helper function to get service by slug
export const getServiceBySlug = (slug: string): ServiceData | undefined => {
    return servicesData.find(service => service.slug === slug);
};

// Helper function to get service by id
export const getServiceById = (id: number): ServiceData | undefined => {
    return servicesData.find(service => service.id === id);
};
